import Layout from '@components/Items/Filters/Layout'
import { FC } from 'react'
import useFilter from '@components/Items/utils/hooks/useFilter'
import { QUERY_KEYS } from '@components/Items/utils/functions'
import _isArray from 'lodash/isArray'
import Checkbox from '@components/Items/components/checkbox'

const AUCTION_TYPES = {
  REGULAR: undefined,
  MEMBER_ONLY: '2'
} as const

const BidftaPlus = () => {
  return (
    <Layout label={'BIDFTA+'}>
      <fieldset>
        <legend className="sr-only">Bidfta+</legend>
        <div className="space-y-1">
          <BidftaPlusCheckbox  label={'Member Only Auctions'} />
        </div>
      </fieldset>
    </Layout>
  )
}

const BidftaPlusCheckbox: FC<{ label: string }> = ({ label }) => {
  const { updateQuery, bidftaPlusQuery } = useFilter()

  const handleChange = async () => {
    await updateQuery(QUERY_KEYS.BIDFTA_PLUS, bidftaPlusQuery === AUCTION_TYPES.MEMBER_ONLY ? AUCTION_TYPES.REGULAR : AUCTION_TYPES.MEMBER_ONLY, true)
  }

  const isChecked = bidftaPlusQuery
    ? _isArray(bidftaPlusQuery)
      ? bidftaPlusQuery.includes(AUCTION_TYPES.MEMBER_ONLY)
      : bidftaPlusQuery === AUCTION_TYPES.MEMBER_ONLY
    : false

  return (
    <Checkbox checked={isChecked} onChange={handleChange}>
      {label}
    </Checkbox>
  )
}

export default BidftaPlus